import React, { Component } from 'react';
import Base from '../../../rebase';
import { 
  Form,
  FormGroup,
  FormControl,
  Button,
  Col,
  ControlLabel
} from 'react-bootstrap';
import PropTypes from 'prop-types';

  var AttendingEnum = {
    UNKNOWN: 1,
    ATTENDING: 2,
    NOTATTENDING: 3,
    properties: {
      1: {
        style: "", 
        summary: "Has not yet responded",
        showDietary: true},
      2: {
        style: "success",
        summary: "Has RSVP'd as attending",
        showDietary: true},
      3: {
        style: "danger", 
        summary: "Has RSVP'd as not attending",
        showDietary: false}
    }
  }

class RSVPSummary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      guest: {
        attending: 1,
        dietary: "",
        givenName: "",
        lastName: "",
        givenName: ""
      }
    };
  }

  componentWillMount() {
    this.ref = Base.fetch('guests/' + this.props.guestID, {
      context: this,
      asArray: false
    }).then(data => {
      this.setState({guest: data});
    });
  }

  render() {
    var guest = this.state.guest;
    var dietary = "Has not submitted any dietary requirements";
    if (guest.dietary != "" || guest.dietary == null) {
      dietary = "Dietary Requirements: " + guest.dietary;
    }

    return (
      <div>
        <Col style={{fontWeight:"Bold",textAlign:"left"}}>{guest.givenName + " " + guest.lastName}</Col>
        <Col style={{paddingLeft:"30px",textAlign:"left"}}>{AttendingEnum.properties[guest.attending].summary}</Col>
        <Col style={{paddingLeft:"30px",textAlign:"left"}}>{dietary}</Col>
      </div>
      );
  }
}

export default RSVPSummary;



// WEBPACK FOOTER //
// ./src/reusable_components/page_components/RSVP/RSVPPersonSummary.jsx